import './Theme/plugins/fancybox/jquery.fancybox.css';
import './Theme/css/css.css';
import './Theme/css/font-awesome-4.7.0/css/font-awesome.min.css';
import './Theme/css/animate.css';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import Header from './Header';
import Menu from './CommonMenu';
import KinhsachPageApi from './KinhsachPageApi';
import { API_URL, FILE_URL, LINK_YOUTUBE_IMAGE } from './Constants';
// import 'slick-carousel/slick/slick-theme.css'; 
import { Worker, Viewer, RenderViewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import $ from 'jquery';
window.jQuery = $;
require('textillate');
require('letteringjs');
require('slick-carousel');


function LoginPage() {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const postId = searchParams.get('postId');
  const title = useState('');

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');

  const pdfUrl = 'https://web2.linhquyphapan.vn/Upload/files/KinhSach/T%C3%A2m%20T%E1%BB%AB%20Vi%20Di%E1%BB%87u.pdf'; // Replace with your PDF link
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [inputPage, setInputPage] = useState(1); // User input for page number

  const onDocumentLoad = ({ doc }) => {
    setTotalPages(doc.numPages); // Set the total pages when the document loads
  };

  const onPageChange = ({ currentPage }) => {
    setCurrentPage(currentPage + 1); // Page numbers are 0-based, so add 1
  };

  const handlePageInputChange = (e) => {
    const value = e.target.value;
    if (value >= 1 && value <= totalPages) {
      setInputPage(value); // Update the input value if it's a valid page number
    }
  };

  const goToPage = () => {
    if (inputPage >= 1 && inputPage <= totalPages) {
      setCurrentPage(inputPage); // Navigate to the page
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoginError('');
    try {
      const res = await axios.post(`${API_URL}/account/login`, { username, password });
      if (res.data && res.data.token) {
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('role', res.data.role);
        localStorage.setItem('userName', res.data.userName);
        window.location.href = '/admin';
      }
    } catch (err) {
      setLoginError('Tài khoản hoặc mật khẩu không chính xác.');
    }
  };

  useEffect(() => {
    $('.tlt').textillate({
      loop: true,
      minDisplayTime: 20000,
      in: {
        effect: 'fadeIn',
        delayScale: 3,
        shuffle: false,
      },
      out: {
        effect: 'fadeOut',
        delayScale: 1.5,
        delay: 100,
        sync: false,
        shuffle: false,
        reverse: false,
      }
    });

    $("#sky-bg").fadeIn(2e3);

    $(".slideHomeFade").slick({
      arrows: !1,
      lazyLoad: "ondemand",
      dots: !1,
      infinite: !0,
      speed: 2e3,
      fade: !0,
      slide: "div",
      autoplay: !0,
      autoplaySpeed: 2e3,
      cssEase: "linear"
    });

    $(".slideKinhSachUpdate").slick({
      infinite: !0,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: !0,
      speed: 3e3,
      dots: !1,
      autoplaySpeed: 5e3,

      // arrows: !1,
    });

    KinhsachPageApi.getDataByPostId(postId).then((data) => {
      setData(data); // Update state with the resolved data
    })

    return () => {
      // Destroy Slick carousel to avoid memory leaks
      $('.slideHomeFade').slick('unslick');
      $('.slideKinhSachUpdate').slick('unslick');
    };

  }, []);
  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta httpEquiv="Content-Language" content="vi" />
      <title>Pháp Ấn Sơn | Linh Quy Pháp Ấn</title>
      <link rel="shortcut icon" href="/Upload/images/tab/logochuan.jpg" type="image/png" />
      <meta name="keywords" content="linh quy pháp ấn; linh quy phap an; Nikaya;  linhquyphapan; linhquy" />
      <meta name="description" content=" Pháp Ấn Sơn" />

      {/* <link href='https://fonts.googleapis.com/css?family=Roboto+Condensed|Open+Sans:400,700,400italic' rel='stylesheet' type='text/css'>
          <link href="/Theme/plugins/fancybox/jquery.fancybox.css" rel="stylesheet" />
          <link href="/Theme/css/css.css" rel="stylesheet"/>
          <link rel="stylesheet" href="/Theme/css/font-awesome-4.7.0/css/font-awesome.min.css">
          <link href="/Theme/css/animate.css" rel="stylesheet" />
          
          <script src="/Theme/js/jquery-1.11.2.min.js"></script> */}
      <div className="fly-text">
        <ul>
          <li className="tlt">Nguyện thành tựu</li>
          <li className="tlt">Lòng tin bất động</li>
          <li className="tlt">Nơi Đức Phật, Chánh Pháp</li>
          <li className="tlt">Chúng Tăng và Thánh Giới</li>
          <li className="tlt" />
        </ul>
      </div>
      <div id="sky-bg">
        <div className="clouds_one" />
        <div className="clouds_two" />
        <div className="clouds_three" />
      </div>
      <Header />

      <section>
        <div className="container contentContainer">
          <div className="row">
            {/* Register Box */}
            <div className="register-box col-md-6 col-sm-12 col-xs-12">
              <h3>Đăng ký tài khoản</h3>
              <a className="btn btn-info" href="/account/Register">
                Đăng ký
              </a>
            </div>

            {/* Login Box */}
            <div className="login-box col-md-6 col-sm-12 col-xs-12">
              <h3>Đăng nhập</h3>
              <form
                onSubmit={handleLogin}
                noValidate
              >
                <span style={{ color: 'red' }}>{loginError}</span>
                <div className="form-group">
                  <strong>Đăng nhập</strong>
                  <br />
                  <input
                    className="input-box form-control"
                    id="UserName"
                    name="UserName"
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  <span
                    className="field-validation-valid"
                    data-valmsg-for="UserName"
                    data-valmsg-replace="true"
                  ></span>
                </div>
                <div className="form-group">
                  <strong>Mật khẩu</strong>
                  <br />
                  <input
                    className="input-box form-control"
                    id="Password"
                    name="Password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span
                    className="field-validation-valid"
                    data-valmsg-for="Password"
                    data-valmsg-replace="true"
                  ></span>
                </div>
                <div>
                  <input
                    data-val="true"
                    data-val-required="The Remember me? field is required."
                    id="RememberMe"
                    name="RememberMe"
                    type="checkbox"
                    value="true"
                  />
                  <input name="RememberMe" type="hidden" value="false" />
                  &nbsp;&nbsp;Ghi nhớ đăng nhập
                </div>
                <br />
                <a href="/account/LostPassword">Quên mật khẩu?</a>
                <br />
                <input type="submit" value="Đăng nhập" className="btn btn-primary" />
              </form>
            </div>

            {/* Clear Fix */}
            <div className="cl"></div>
          </div>
        </div>
      </section>

      <footer>
        <div className="container">
          {/* <div className="_Slide3DContainer wow fadeInUp" data-wow-delay="0.4s">
            <ul className="carousel ">
              <li className="item active">
                <a href="/kinh-sach/cua-vao-bat-tu" className="itemSlide3d" tipcontent="CỬA VÀO BẤT TỬ"><img src={require("./Upload/images/z2345923129108_b9a2cd08e07aba3cab7e274c4c1896db.jpg")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/nghi-thuc-tu-hoc-nikaya" className="itemSlide3d"><img src={require("./Upload/images/Nghi Thức Tu Học NIKAYA(1).jpg")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/phap-hanh-nikaya-can-ban" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/tam-hy-ngot-ngao" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/tam-hien-van-an" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
            </ul>
          </div> */}
        </div>
      </footer>
      <section className="footer-copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-1">
              <img className="img-responsive" src={require("./Theme/img/linhqquylogo-small.jpg")} />
            </div>
            <div className="col-md-5">
              Copyright © 2011 - 2024<br />Linhquyphapan.vn, All right reserved <br />Chủ nhiệm: Thượng Toạ Thích Minh Thành
            </div>
            <div className="col-md-6">
              Thôn 4 - Xã Lộc Thành - Huyện Bảo Lâm - Tỉnh Lâm Đồng <br />SĐT: 0963 232 651 , 0766 522 181<br />Email: linhquyphapan@yahoo.com <br /> www.linhquyphapan.vn
            </div>
          </div>
        </div>
      </section>
      <p id="back-top" style={{ display: 'none' }}>
        <a href="#top"><span /></a>
      </p>
      <div id="fb-root" />
    </div>
  );
}

export default LoginPage;
